import { Component, OnInit } from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators
} from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { PartnerConfigurationService } from '../services/partner-configuration.service';
import { PartnerCUModel } from '../dto/response-dto/partner-details-response-dto';
import { ConcatinatedList, ModifiedConfigurationResponse } from '../interface/modified-configuration';
import { Duration } from '../interface/durations';
import { CoverageLevel } from '../interface/coverage-levels';
import { PartnerConfiguration } from '../interface/partner-configuration-data';
import { Configurations } from '../interface/configurations';
import { Partner } from '../interface/partners-data';
import { PartnerLimitRequestDTO } from '../dto/request-dto/partner-limit-request-dto';
import { ProductConfigurationData } from '../dto/response-dto/product-configuration-response-dto';
import { ProgressIndicatingService } from 'src/app/modules/shared/services/progress-indicating.service';
import { Subject } from 'rxjs';
import { ProgressData } from 'src/app/modules/shared/dtos/progress-data';
import { FrequencyLimitUnitLabels, FrequencyLimitUnitsForResend, FrequencyLimitUnitsWithoutPlural } from '../../topcon-configuration/dtos/frequency-limit-unit.enum';

@Component({
    selector: 'app-partner-configuration',
    templateUrl: './partner-configuration.component.html',
    styleUrls: ['./partner-configuration.component.scss']
})
export class PartnerConfigurationComponent implements OnInit {
    public errorMessage: string = '';
    public noRecordsFound = false;
    public productDialog: boolean;
    public isDataAvailable: boolean = false;
    public isProductDataAvailable: boolean = false;
    public disableButton: boolean = true;
    public errorResponseCode: boolean = false;
    public enableSaveDetails: boolean = false;

    public selectedPartnerName: string = '';
    public Orgid: number = 0;
    public partnerDetails: PartnerCUModel[];
    public clonedProducts: { [s: string]: ModifiedConfigurationResponse; } = {};

    public selectedDurationData: Duration[] = [];
    public selectedCoverageData: CoverageLevel[] = [];
    public selectedCoverageProductData: CoverageLevel[] = [];
    public configurationListById: PartnerConfiguration;
    public configurations: Configurations[] = [];

    public durationResponse: ConcatinatedList[];
    public coverageLevelResponse: CoverageLevel[];
    public partnerConfigurationList: ModifiedConfigurationResponse[] = [];

    public selectedConfiguration: ProductConfigurationData = {};
    public onSelectedValueChange: boolean = false;
    public partnerObj: Partner[] = [];
    public finalSelectedDurationData: Duration[] = [];
    public previousRowIndex: number = -1;
    public limitUnits: Array<string> = [];
    public frequencyLimitUnitsForResend: Array<string> = [];
    private progress$ = new Subject<ProgressData>();

    public constructor(public fb: FormBuilder,
        private configurationService: PartnerConfigurationService,
        private confirmationService: ConfirmationService,
        private progressService: ProgressIndicatingService,
        private messageService: MessageService
    ) { }

    public partnerSpecificForm = new FormGroup({
        partnerId: new FormControl('', null),
        partnerName: new FormControl('', null),
        noOfResends: new FormControl('', [Validators.required, Validators.pattern(/^[0-9]+$/), Validators.max(1000)]),
        maxTestActivation: new FormControl('', [Validators.required, Validators.pattern(/^[0-9]+$/), Validators.max(1000)]),
        perResendUnit: new FormControl('', Validators.required),
        perTestUnit: new FormControl('', Validators.required)
    });

    public newPartnerForm = new FormGroup({
        productCode: new FormControl('', [
            Validators.required
        ]),
        duration: new FormControl('', Validators.required),
        coverageLevel: new FormControl('', Validators.required)
    })

    public ngOnInit(): void {
        this.isDataAvailable = false;
        this.isProductDataAvailable = false;
        this.enableSaveDetails = false;
        // this.limitUnits = ['HOUR', 'WEEK', 'MONTH', 'YEAR'];
        this.limitUnits = Object.values(FrequencyLimitUnitsWithoutPlural);
        this.frequencyLimitUnitsForResend = Object.values(FrequencyLimitUnitsForResend);
        this.getParterDetails();
        this.getConfigurationSelection();
    }

    /* onchange partnerId bind partner name */
    public onChangePartnerId(event: { value: { organizationDisplayName: string, organizationId: number } }): void {
        this.selectedPartnerName = event.value.organizationDisplayName;
        this.Orgid = event.value.organizationId;
        this.isDataAvailable = false;

        if (this.selectedPartnerName !== null || this.selectedPartnerName !== '' || this.selectedPartnerName !== undefined) {
            this.disableButton = false;
        } else {
            this.disableButton = true;
        }
        this.getPartnerConfigurationById();
    }

    public enableSingleRow(id: string): void {
        const cancel = document.getElementById(id);
        if (cancel) {
            cancel.click();
        }
    }

    public onRowEditInit(product: ModifiedConfigurationResponse, rowIndex? : number): void {
        if (this.previousRowIndex === -1) {
            this.previousRowIndex = rowIndex!;
        }
        this.clonedProducts[product.productCode!] = { ...product };
        this.enableSingleRow('productcancel' + this.previousRowIndex);
        this.previousRowIndex = rowIndex!;
    }

    public onRowEditSave(product: ModifiedConfigurationResponse): void {
        this.progressService.show({
            progress$: this.progress$,
            initial: {
                done: false,
                header: 'Updating Product Details',
                details: 'Please wait...'
            }
        });
        if (this.onSelectedValueChange === false) {
            this.selectedConfiguration.configurationData = product.configurations;
        };
        // this.partnerConfigurationList = [];
        this.configurationService.updateConfiguration(this.selectedConfiguration).subscribe(result => {
            if (result.responseCode === 0) {
                this.sendProgressDoneSignal();
                this.apiResponsePopup(result.responseMessage!, result.responseCode!);
            }
        },
        error => {
            this.sendProgressDoneSignal();
            this.apiResponsePopup(error.error.responseMessage, error.error.responseCode);
            this.partnerConfigurationList.forEach(x => {
                const clonedData = this.clonedProducts[product.productCode!];
                if (x.productCode === clonedData.productCode) {
                    x.coverageLevels = clonedData.coverageLevels!;
                    x.concatinatedList = clonedData.concatinatedList!;
                }
            });
        });
    }

    public onRowEditCancel(product: ModifiedConfigurationResponse, index? : number): void {
        this.partnerConfigurationList.forEach(x => {
            const clonedData = this.clonedProducts[product.productCode!];
            if (x.productCode === clonedData.productCode) {
                x.coverageLevels = clonedData.coverageLevels!;
                x.concatinatedList = clonedData.concatinatedList!;
            }
        });
        delete this.clonedProducts[product.productCode!];
    }

    /* get all partner details */
    public getParterDetails(): void {
        this.progressService.show({
            progress$: this.progress$.asObservable(),
            initial: {
                header: 'Loading Partner Information Details',
                details: 'Please wait...',
                done: false
            }
        });
        this.configurationService.getPartnerDetails().subscribe(result => {
            if (result.responseCode === 0) {
                this.sendProgressDoneSignal();
                this.partnerDetails = result.partnerCUModel;
                this.partnerObj = result.partnerCUModel;
            } else {
                this.errorMessage = result.responseMessage!;
            }
        }, (error) => {
            this.messageService.add({ severity: 'error', summary: 'Fail', detail: error.error.responseMessage });
            this.sendProgressDoneSignal();
        });
    }

    /* get partner details by id */
    public getPartnerConfigurationById(): void {
        this.configurations = [];
        this.partnerConfigurationList = [];
        this.configurationListById = {};
        this.selectedDurationData = [];
        this.selectedCoverageData = [];
        this.selectedConfiguration = {};
        this.enableSaveDetails = false;
        this.progressService.show({
            progress$: this.progress$.asObservable(),
            initial: {
                header: 'Loading Partner Information Details',
                details: 'Please wait...',
                done: false
            }
        });
        this.configurationService.getPartnerConfiguration(this.Orgid).subscribe(result => {
            if (result.responseCode === 0) {
                this.isDataAvailable = true;
                this.noRecordsFound = true;
                this.isProductDataAvailable = false;
                this.configurationListById = result.partnerConfiguration!;
                if (this.configurationListById.configurations !== undefined) {
                    this.isProductDataAvailable = false;
                    this.configurations = result.partnerConfiguration?.configurations!;
                    this.configurations?.forEach(config => {
                        const configObj: ModifiedConfigurationResponse = {
                            durations: [],
                            coverageLevels: [],
                            concatinatedList: [],
                            productCode: '',
                            partnerConfigId: 0,
                            configurations: {}
                        };
                        const concateList: ConcatinatedList[] = [];
                        configObj.productCode = config.productCode!;
                        configObj.durations = config.durations!;
                        configObj.coverageLevels = config.coverageLevels!;
                        configObj.partnerConfigId = config.partnerConfigId!;
                        configObj.configurations = config;
                        configObj.coverageData = config.coverageLevels?.map(x => x.name).join(', ');
                        configObj.durationData = config.durations?.map(x => x.name + FrequencyLimitUnitLabels[x.value!]).join(', ');
                        config.durations?.forEach(durationItem => {
                            const concatObj: ConcatinatedList = {
                                id: 0,
                                name: '',
                                value: '',
                                concatinatedName: '',
                                modelStatus: 0
                            };
                            concatObj.name = durationItem.name!;
                            concatObj.value = durationItem.value!;
                            concatObj.id = durationItem.id!;
                            concatObj.modelStatus = durationItem.modelStatus!;
                            concatObj.concatinatedName = durationItem.name + '' + durationItem.value?.charAt(0);
                            concateList.push(concatObj);
                        });
                        configObj.concatinatedList = concateList;
                        const mergedData = {
                            month: configObj.concatinatedList.filter(item => item.concatinatedName?.endsWith('M')).map(x => x.concatinatedName).join(', '),
                            year: configObj.concatinatedList.filter(item => item.concatinatedName?.endsWith('Y')).map(x => x.concatinatedName).join(', '),
                            week: configObj.concatinatedList.filter(item => item.concatinatedName?.endsWith('W')).map(x => x.concatinatedName).join(', '),
                            hour: configObj.concatinatedList.filter(item => item.concatinatedName?.endsWith('H')).map(x => x.concatinatedName).join(', ')
                        };
                        const frequencyLimitsData = [];
                        if (mergedData?.year !== '') {
                            frequencyLimitsData.push(mergedData?.year!);
                        }
                        if (mergedData?.month !== '') {
                            frequencyLimitsData.push(mergedData?.month!);
                        }
                        if (mergedData?.week !== '') {
                            frequencyLimitsData.push(mergedData?.week!);
                        }
                        if (mergedData?.hour !== '') {
                            frequencyLimitsData.push(mergedData?.hour!);
                        }
                        configObj.sortedData = frequencyLimitsData;
                        this.partnerConfigurationList.push(configObj);
                    });
                } else {
                    this.isProductDataAvailable = true;
                }
                this.partnerSpecificForm.patchValue({
                    noOfResends: this.configurationListById.partner?.resendLimit,
                    perResendUnit: this.configurationListById.partner?.resendLimitUnits.toUpperCase().substring(0, this.configurationListById.partner?.resendLimitUnits.length - 1),
                    maxTestActivation: this.configurationListById.partner?.testActivationLimit,
                    perTestUnit: this.configurationListById.partner?.testActivationLimitUnits.toUpperCase().substring(0, this.configurationListById.partner?.testActivationLimitUnits.length - 1)
                });
                this.sendProgressDoneSignal();
            } else {
                this.isDataAvailable = false;
                this.noRecordsFound = true;
                this.errorMessage = result.responseMessage!;
                this.isProductDataAvailable = false;
            }
        }, (error) => {
            this.noRecordsFound = true;
            this.isProductDataAvailable = false;
            this.messageService.add({ severity: 'error', summary: 'Fail', detail: error.error.responseMessage });
            this.sendProgressDoneSignal();
        });
    }

    public deleteProduct(product: Configurations): void {
        this.confirmationService.confirm({
            message: 'Do you want to delete \'' + product.productCode + '\'?',
            header: 'Confirmation',
            icon: 'pi pi-info-circle',
            acceptLabel: 'Ok',
            acceptVisible: true,
            rejectLabel: 'Cancel',
            rejectVisible: true,
            accept: () => {
                this.progressService.show({
                    progress$: this.progress$.asObservable(),
                    initial: {
                        header: 'Deleting Partner Configurations Details',
                        details: 'Please wait...',
                        done: false
                    }
                });
                this.configurationService.DeleteById(product.partnerConfigId!).subscribe(result => {
                    if (result.responseCode === 0) {
                        this.sendProgressDoneSignal();
                        this.apiResponsePopup(result.responseMessage!, result.responseCode!);
                    }
                }, (error) => {
                    this.apiResponsePopup(error.error.responseMessage!, error.responseCode!);
                    this.sendProgressDoneSignal();
                });
            }
        });
    }

    private apiResponsePopup(responseMsg: string, responseCode: number) :void {
        if (responseCode === 0) {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: responseMsg });
            this.getPartnerConfigurationById();
            this.onRequestComplete();
        } else {
            this.messageService.add({ severity: 'error', summary: 'Fail', detail: responseMsg });
        }
    }

    public cancelDetails(): void {
        this.productDialog = false;
        this.newPartnerForm.reset();
    }

    public onUpdateLimitations(): void {
        this.progressService.show({
            progress$: this.progress$.asObservable(),
            initial: {
                header: 'Updating Limitation Details',
                details: 'Please wait...',
                done: false
            }
        });
        let data: Partner[] = [];
        const requestBody: PartnerLimitRequestDTO = {};
        data = this.partnerObj.filter(ele => ele.organizationId === this.Orgid);
        requestBody.configurationData = {
            organizationId: data[0].organizationId,
            partnerId: data[0].partnerId,
            organizationDisplayName: data[0].organizationDisplayName,
            email: data[0].email,
            resendLimit: this.partnerSpecificForm.value.noOfResends,
            resendLimitUnits: this.partnerSpecificForm.value.perResendUnit.toUpperCase(),
            testActivationLimit: this.partnerSpecificForm.value.maxTestActivation,
            testActivationLimitUnits: this.partnerSpecificForm.value.perTestUnit.toUpperCase(),
            isTopconPartner: data[0].isTopconPartner
        };
        this.configurationService.updatePartnerLimit(requestBody).subscribe(result => {
            if (result.responseCode === 0) {
                this.sendProgressDoneSignal();
                this.apiResponsePopup(result.responseMessage!, result.responseCode!);
            }
        }, (error) => {
            this.apiResponsePopup(error.error.responseMessage!, error.responseCode!);
            this.sendProgressDoneSignal();
        });
    }

    public saveNewProductDetails(): void {
        this.progressService.show({
            progress$: this.progress$.asObservable(),
            initial: {
                header: 'Saving Product Details',
                details: 'Please wait...',
                done: false
            }
        });
        const partnerConfigData = {
            configurationData: {
                organizationId: this.Orgid,
                productCode: this.newPartnerForm.value.productCode,
                durations: this.selectedDurationData,
                coverageLevels: this.selectedCoverageProductData,
                modelStatus: 0
            }
        };
        this.configurationService.postConfigurationProduct(partnerConfigData).subscribe(request => {
            if (request.responseCode === 0) {
                this.sendProgressDoneSignal();
                this.getConfigurationSelection();
                this.apiResponsePopup(request.responseMessage!, request.responseCode!);
            }
        }, (error) => {
            this.apiResponsePopup(error.error.responseMessage!, error.responseCode!);
            this.sendProgressDoneSignal();
        });
    }

    public onAddNewProduct(): void {
        this.selectedCoverageProductData = [];
        this.selectedDurationData = [];
        this.selectedCoverageData = [];
        this.newPartnerForm.reset();
        this.productDialog = true;
    }

    public onChangeProductDuration(event: { value: [{ id: number, name: string, modelStatus: number, value: string }] }): void {
        this.selectedDurationData = [];
        event.value?.forEach(durationItem => {
            const newDurationObj = {
                id: 0,
                name: '',
                value: '',
                modelStatus: 0
            };
            newDurationObj.id = durationItem.id!;
            newDurationObj.name = durationItem.name!;
            newDurationObj.value = durationItem.value!;
            newDurationObj.modelStatus = 1;
            this.selectedDurationData.push(newDurationObj);
        });
    }

    public onChangeProductCoverageLevel(event: { value: [{ modelStatus: number }] }): void {
        this.selectedCoverageProductData = [];
        event.value?.forEach(item => {
            item.modelStatus = 1;
        });
        this.selectedCoverageProductData = event.value;
    }

    public onChangeCoverageLevel(event: { value: [{ modelStatus: number, id: number }], itemValue: { id: number } }, product: { configurations: { coverageLevels: CoverageLevel[] }, coverageLevels: CoverageLevel[] }): void {
        this.selectedCoverageData = [];
        this.onSelectedValueChange = true;
        this.selectedConfiguration = {};

        /* for setting model status as 0, 1 and 3 and checking the items are added newly or deleting the selecteditem based on id */
        const existingCoverageData: CoverageLevel[] = [];
        const nonExistingCoverageData: CoverageLevel[] = [];
        const removedCoverageData: CoverageLevel[] = [];
        const tempObj = JSON.parse(JSON.stringify(this.coverageLevelResponse)); // overall coverage-response
        tempObj.forEach((coverageId : CoverageLevel) => {
            let checkIfExists: boolean = false;
            checkIfExists = this.compareCoverageId(product.configurations.coverageLevels, coverageId.id!);
            /* pushing items already exists in selected list */
            if (checkIfExists) {
                coverageId.modelStatus = 0;
                existingCoverageData.push(coverageId);
            } else {
                /* pushing items not exists in selected list */
                event.value?.forEach(item => {
                    if (item.id === coverageId.id) {
                        coverageId.modelStatus = 1;
                        nonExistingCoverageData.push(coverageId);
                    }
                });
            }
        });
        /* pushing items already exists in selected list and unchecking from the selected list */
        existingCoverageData?.forEach(coverageId => {
            let checkIfIdExists: boolean = false;
            checkIfIdExists = this.compareCoverageId(event.value, coverageId.id!);
            if (!checkIfIdExists) {
                coverageId.modelStatus = 3;
            }
            removedCoverageData.push(coverageId);
        });
        this.selectedCoverageData = [...removedCoverageData, ...nonExistingCoverageData];
        const configObj = JSON.parse(JSON.stringify(product.configurations));
        configObj.coverageLevels = this.selectedCoverageData;
        this.selectedConfiguration.configurationData = configObj;
    }

    public onChangeDuration(event: { value: [{ id: number, name: string, modelStatus: number, value: string }] }, product: {
        partnerConfigId: number,
        concatinatedList: ConcatinatedList[], configurations: { durations: Duration[] }
    }): void {
        this.onSelectedValueChange = true;
        this.finalSelectedDurationData = [];
        this.selectedDurationData = [];
        this.selectedConfiguration = {};
        const existingDurationData: Duration[] = [];
        const nonExistingDurationData: Duration[] = [];
        const removedDurationData: Duration[] = [];
        let tempObj = [];
        tempObj = JSON.parse(JSON.stringify(this.durationResponse)); // overall coverage-response
        let checkIfExists: boolean = false;
        tempObj.forEach((durationId : Duration) => {
            checkIfExists = this.compareDurationId(product.configurations.durations, durationId.id!);
            if (checkIfExists) {
                if (product.configurations.durations.find(x => x.id === durationId.id)?.modelStatus === 1) {
                    durationId.modelStatus = 1;
                }
                existingDurationData.push(durationId);
            } else {
                event.value?.forEach(item => {
                    if (item.id === durationId.id) {
                        durationId.modelStatus = 1;
                        nonExistingDurationData.push(durationId);
                    }
                });
            }
        });
        existingDurationData?.forEach(durationId => {
            let checkIfIdExists: boolean = false;
            checkIfIdExists = this.compareDurationId(event.value, durationId.id!);
            if (!checkIfIdExists) {
                durationId.modelStatus = 3;
            };
            removedDurationData.push(durationId);
        });
        this.selectedDurationData = [...removedDurationData, ...nonExistingDurationData];
        /* setting the list same as the actual list as it contains concatinated data(need to remove concatinated name) */
        this.selectedDurationData?.forEach(item => {
            const selectedDurationObj: Duration = {
                id: item.id,
                name: item.name,
                value: item.value,
                modelStatus: item.modelStatus
            };
            this.finalSelectedDurationData.push(selectedDurationObj);
        });

        const configObj = product.configurations;
        configObj.durations = this.finalSelectedDurationData;
        this.selectedConfiguration.configurationData = configObj;
    }

    public getConfigurationSelection(): void {
        this.durationResponse = [];
        this.coverageLevelResponse = [];
        // this.partnerConfigurationList = [];
        this.configurationService.getConfigurationSelection().subscribe(result => {
            if (result.responseCode === 0) {
                const selectionObj: ModifiedConfigurationResponse = {
                    durations: [],
                    coverageLevels: [],
                    concatinatedList: []
                };
                const concateList: ConcatinatedList[] = [];
                selectionObj.durations = result.selections.durations!;
                selectionObj.coverageLevels = result.selections.coverageLevels!;
                result.selections.durations?.forEach(durationItem => {
                    const concatObj: ConcatinatedList = {
                        id: 0,
                        name: '',
                        value: '',
                        concatinatedName: '',
                        modelStatus: 0
                    };
                    concatObj.name = durationItem.name;
                    concatObj.value = durationItem.value;
                    concatObj.id = durationItem.id;
                    concatObj.modelStatus = durationItem.modelStatus!;
                    concatObj.concatinatedName = durationItem.name + '' + durationItem.value!.charAt(0);
                    concateList.push(concatObj);
                });

                selectionObj.concatinatedList = concateList;
                selectionObj.sortedData = [];
                this.durationResponse = [...concateList];
                this.durationResponse.sort((a, b) => {
                    if (a.value === b.value) {
                        return +a.name! - +b.name!;
                    } else {
                        return a.value! > b.value! ? -1 : 1;
                    }
                });
                this.coverageLevelResponse = selectionObj.coverageLevels;
                // this.partnerConfigurationList.push(selectionObj);
                this.partnerSpecificForm.patchValue({
                    duration: this.durationResponse,
                    coverageLevel: selectionObj.coverageLevels
                });
            }
        }, (error) => {
            this.messageService.add({ severity: 'error', summary: 'Fail', detail: error.error.responseMessage });
        });
    }

    public compareCoverageId(coverageList: CoverageLevel[], id: number): boolean {
        let modelStatusFlag: boolean = false;
        coverageList?.forEach(item => {
            if (item.id === id) {
                modelStatusFlag = true;
            }
        });
        return modelStatusFlag;
    }

    public compareDurationId(durationList: Duration[], id: number): boolean {
        let modelStatusFlag: boolean = false;
        durationList?.forEach(item => {
            if (item.id === id) {
                modelStatusFlag = true;
            }
        });
        return modelStatusFlag;
    }

    private onRequestComplete() : void {
        this.isDataAvailable = false;
        this.productDialog = false;
    }

    public onChangeResendLimitations(event : { value : number}) : void {
        if (event.value !== this.configurationListById.partner?.resendLimit ||
            this.partnerSpecificForm.value.maxTestActivation !== this.configurationListById.partner?.testActivationLimit) {
            this.enableSaveDetails = true;
        } else {
            this.enableSaveDetails = false;
        }
    }

    public onChangeActivationLimitations(event : { value : number}) : void {
        if (event.value !== this.configurationListById.partner?.testActivationLimit ||
            this.partnerSpecificForm.value.noOfResends !== this.configurationListById.partner?.resendLimit) {
            this.enableSaveDetails = true;
        } else {
            this.enableSaveDetails = false;
        }
    }

    public onChangeInput(event : { perResendUnit: string, perTestUnit : string}) : void {
        if (this.configurationListById.partner?.resendLimitUnits !== event.perResendUnit ||
            this.configurationListById.partner?.testActivationLimitUnits !== event.perTestUnit) {
            this.enableSaveDetails = true;
        } else {
            this.enableSaveDetails = false;
        }
    }

    private sendProgressDoneSignal(): void {
        this.progress$.next({
            header: '',
            done: true
        });
    }
}
